// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Decco from "decco/src/Decco.bs.js";
import * as Js_dict from "rescript/lib/es6/js_dict.js";
import * as Js_json from "rescript/lib/es6/js_json.js";
import * as Belt_Option from "rescript/lib/es6/belt_Option.js";
import * as App_Types_Date$DvmAdminFrontendFr from "../../../../../common/types/App_Types_Date.bs.js";

function requestItem_encode(v) {
  return Js_dict.fromArray([
              [
                "actionId",
                Decco.stringToJson(v.actionId)
              ],
              [
                "amount",
                Decco.optionToJson(Decco.floatToJson, v.amount)
              ],
              [
                "comment",
                Decco.optionToJson(Decco.stringToJson, v.comment)
              ],
              [
                "creationDate",
                Decco.optionToJson(App_Types_Date$DvmAdminFrontendFr.Decco.t_encode, v.creationDate)
              ],
              [
                "orderId",
                Decco.stringToJson(v.orderId)
              ],
              [
                "userId",
                Decco.optionToJson(Decco.stringToJson, v.userId)
              ]
            ]);
}

function requestItem_decode(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var actionId = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "actionId"), null));
  if (actionId.TAG === /* Ok */0) {
    var amount = Decco.optionFromJson(Decco.floatFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "amount"), null));
    if (amount.TAG === /* Ok */0) {
      var comment = Decco.optionFromJson(Decco.stringFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "comment"), null));
      if (comment.TAG === /* Ok */0) {
        var creationDate = Decco.optionFromJson(App_Types_Date$DvmAdminFrontendFr.Decco.t_decode, Belt_Option.getWithDefault(Js_dict.get(dict$1, "creationDate"), null));
        if (creationDate.TAG === /* Ok */0) {
          var orderId = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "orderId"), null));
          if (orderId.TAG === /* Ok */0) {
            var userId = Decco.optionFromJson(Decco.stringFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "userId"), null));
            if (userId.TAG === /* Ok */0) {
              return {
                      TAG: /* Ok */0,
                      _0: {
                        actionId: actionId._0,
                        amount: amount._0,
                        comment: comment._0,
                        creationDate: creationDate._0,
                        orderId: orderId._0,
                        userId: userId._0
                      }
                    };
            }
            var e = userId._0;
            return {
                    TAG: /* Error */1,
                    _0: {
                      path: ".userId" + e.path,
                      message: e.message,
                      value: e.value
                    }
                  };
          }
          var e$1 = orderId._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: ".orderId" + e$1.path,
                    message: e$1.message,
                    value: e$1.value
                  }
                };
        }
        var e$2 = creationDate._0;
        return {
                TAG: /* Error */1,
                _0: {
                  path: ".creationDate" + e$2.path,
                  message: e$2.message,
                  value: e$2.value
                }
              };
      }
      var e$3 = comment._0;
      return {
              TAG: /* Error */1,
              _0: {
                path: ".comment" + e$3.path,
                message: e$3.message,
                value: e$3.value
              }
            };
    }
    var e$4 = amount._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".amount" + e$4.path,
              message: e$4.message,
              value: e$4.value
            }
          };
  }
  var e$5 = actionId._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".actionId" + e$5.path,
            message: e$5.message,
            value: e$5.value
          }
        };
}

function requestsList_encode(v) {
  return Decco.listToJson(requestItem_encode, v);
}

function requestsList_decode(v) {
  return Decco.listFromJson(requestItem_decode, v);
}

var DealerRequests = {
  requestItem_encode: requestItem_encode,
  requestItem_decode: requestItem_decode,
  requestsList_encode: requestsList_encode,
  requestsList_decode: requestsList_decode
};

function documentItem_encode(v) {
  return Js_dict.fromArray([
              [
                "orderId",
                Decco.stringToJson(v.orderId)
              ],
              [
                "actionId",
                Decco.stringToJson(v.actionId)
              ],
              [
                "fileId",
                Decco.optionToJson(Decco.stringToJson, v.fileId)
              ],
              [
                "fileName",
                Decco.optionToJson(Decco.stringToJson, v.fileName)
              ],
              [
                "fileType",
                Decco.optionToJson(Decco.stringToJson, v.fileType)
              ],
              [
                "comment",
                Decco.optionToJson(Decco.stringToJson, v.comment)
              ],
              [
                "userId",
                Decco.optionToJson(Decco.stringToJson, v.userId)
              ],
              [
                "importDate",
                Decco.optionToJson(App_Types_Date$DvmAdminFrontendFr.Decco.t_encode, v.importDate)
              ]
            ]);
}

function documentItem_decode(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var orderId = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "orderId"), null));
  if (orderId.TAG === /* Ok */0) {
    var actionId = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "actionId"), null));
    if (actionId.TAG === /* Ok */0) {
      var fileId = Decco.optionFromJson(Decco.stringFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "fileId"), null));
      if (fileId.TAG === /* Ok */0) {
        var fileName = Decco.optionFromJson(Decco.stringFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "fileName"), null));
        if (fileName.TAG === /* Ok */0) {
          var fileType = Decco.optionFromJson(Decco.stringFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "fileType"), null));
          if (fileType.TAG === /* Ok */0) {
            var comment = Decco.optionFromJson(Decco.stringFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "comment"), null));
            if (comment.TAG === /* Ok */0) {
              var userId = Decco.optionFromJson(Decco.stringFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "userId"), null));
              if (userId.TAG === /* Ok */0) {
                var importDate = Decco.optionFromJson(App_Types_Date$DvmAdminFrontendFr.Decco.t_decode, Belt_Option.getWithDefault(Js_dict.get(dict$1, "importDate"), null));
                if (importDate.TAG === /* Ok */0) {
                  return {
                          TAG: /* Ok */0,
                          _0: {
                            orderId: orderId._0,
                            actionId: actionId._0,
                            fileId: fileId._0,
                            fileName: fileName._0,
                            fileType: fileType._0,
                            comment: comment._0,
                            userId: userId._0,
                            importDate: importDate._0
                          }
                        };
                }
                var e = importDate._0;
                return {
                        TAG: /* Error */1,
                        _0: {
                          path: ".importDate" + e.path,
                          message: e.message,
                          value: e.value
                        }
                      };
              }
              var e$1 = userId._0;
              return {
                      TAG: /* Error */1,
                      _0: {
                        path: ".userId" + e$1.path,
                        message: e$1.message,
                        value: e$1.value
                      }
                    };
            }
            var e$2 = comment._0;
            return {
                    TAG: /* Error */1,
                    _0: {
                      path: ".comment" + e$2.path,
                      message: e$2.message,
                      value: e$2.value
                    }
                  };
          }
          var e$3 = fileType._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: ".fileType" + e$3.path,
                    message: e$3.message,
                    value: e$3.value
                  }
                };
        }
        var e$4 = fileName._0;
        return {
                TAG: /* Error */1,
                _0: {
                  path: ".fileName" + e$4.path,
                  message: e$4.message,
                  value: e$4.value
                }
              };
      }
      var e$5 = fileId._0;
      return {
              TAG: /* Error */1,
              _0: {
                path: ".fileId" + e$5.path,
                message: e$5.message,
                value: e$5.value
              }
            };
    }
    var e$6 = actionId._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".actionId" + e$6.path,
              message: e$6.message,
              value: e$6.value
            }
          };
  }
  var e$7 = orderId._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".orderId" + e$7.path,
            message: e$7.message,
            value: e$7.value
          }
        };
}

function documentList_encode(v) {
  return Decco.listToJson(documentItem_encode, v);
}

function documentList_decode(v) {
  return Decco.listFromJson(documentItem_decode, v);
}

export {
  DealerRequests ,
  documentItem_encode ,
  documentItem_decode ,
  documentList_encode ,
  documentList_decode ,
}
/* App_Types_Date-DvmAdminFrontendFr Not a pure module */
